import styled from 'styled-components'

export const FlagAndNameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};

  span {
    font-size: 24px;
  }
`

export const IndexContainer = styled.td`
  text-align: center;
  color: ${props => props.theme.colors.text.subtle};
  width: fit-content;
`

export const AmountsContainer = styled.td`
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp16};
  text-align: right;
`

export const Container = styled.tr`
  border-radius: ${props => props.theme.primitives.radius.radius2};

  td:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  td:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  &:hover {
    cursor: pointer;
    background-color: ${props => props.theme.colors.background.secondary};
  }
`
